import React, { useEffect } from 'react';

/**
 * PointsToast — floating celebration overlay when a user earns Ihsan Points.
 * Not a toast notification. A centred card with backdrop + auto-dismiss.
 *
 * Requires the `fillBar` keyframe in index.css:
 *   @keyframes fillBar { from { width: 0% } to { width: 100% } }
 */
export default function PointsToast({ isVisible, points = 0, action = '', onDismiss }) {
  useEffect(() => {
    if (!isVisible) return undefined;
    const t = setTimeout(() => onDismiss?.(), 2500);
    return () => clearTimeout(t);
  }, [isVisible, onDismiss]);

  if (!isVisible) return null;

  return (
    <div
      data-testid="points-toast"
      role="status"
      aria-live="polite"
      className="fixed inset-0 z-[100] flex items-center justify-center px-4"
    >
      <div
        aria-hidden="true"
        onClick={onDismiss}
        className="absolute inset-0 bg-black/40"
      />
      <div
        className="relative bg-white rounded-2xl shadow-2xl p-6 text-center w-[280px] max-w-full"
        style={{ animation: 'fadeInUp 0.25s ease-out' }}
      >
        <div className="text-5xl leading-none mb-3" aria-hidden="true">⭐</div>
        <h3 className="text-2xl font-bold text-[#1B5E20] leading-tight">
          +{points} Ihsan Points!
        </h3>
        {action && (
          <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
            {action}
          </p>
        )}
        <div className="mt-5 relative h-1 w-full rounded-full bg-muted overflow-hidden">
          <div
            className="absolute inset-y-0 left-0 bg-[#1B5E20] rounded-full"
            style={{ animation: 'fillBar 2.5s linear forwards' }}
          />
        </div>
      </div>
    </div>
  );
}
